
import { LockedArt } from '@/components/illustrations';
import { Button, Card, CardContent } from '@/components/cargofl-ui';
import { useSignOut } from '@/lib/session';

/**
 * The employee record is EXITED.
 *
 * A separate destination from the login page on purpose: their Google credentials
 * are perfectly valid, so sending them to sign in again would succeed and bounce
 * them straight back here.
 */
export function AccountDisabledPage() {
  const signOut = useSignOut();

  return (
    <div className="flex min-h-dvh items-center justify-center p-6">
      <Card className="w-full max-w-md">
        <CardContent className="space-y-5 py-10 sm:py-10">
          <LockedArt className="-ml-2 h-20 w-auto" />

          <div className="space-y-2">
            <h1 className="text-xl font-bold tracking-[-0.01em]">Account no longer active</h1>
            <p className="text-sm text-muted-foreground">
              Your employee record has been marked as exited, so the performance system is closed to
              you. Past appraisal records are retained and remain accessible to HR.
            </p>
          </div>

          <p className="text-sm text-muted-foreground">
            If this is wrong, contact HR — signing in again will not change it.
          </p>

          <Button variant="outline" onClick={() => void signOut()}>
            Sign out
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
